export const PHRASE_FILTER = 'phrase';
export const PATTERNHASH_FILTER = 'pattern_hash';
export const PATTERN_FILTER = 'pattern';
export const ENTITY_TYPE_FILTER = 'entity_type';
export const ENTITY_VALUE_FILTER = 'entity_type_value';
export const DIALOG_FILTER = 'dialogId';

export const RUNTIME_ERROR = 'runtime_error';
export const INFO = 'info';
export const OUTPUT_PHRASES = 'outputPhrases';
export const INPUT_PHRASES = 'inputPhrases';
export const UNRECOGNIZED_PHRASES = 'unrecognizedPhrases';
export const ENTITIES = 'entities';